//#region  Publish Subscribe constants
export const publishSubscribeEvents = {
    outdatedData: 'Outdated Data'
}
//#endregion

//#region Server-Sent Event Types
export const serverSentTypes = {
    outdatedProject: 'Outdated Project'
}